<adapt-dialog [maxWidth]="500">
    <h3 adapt-dialog-title>Provide feedback</h3>

    <ng-container adapt-dialog-content>
        @if (alreadyHasFeedback) {
            <h3>Thanks!</h3>
            <p>We have already received feedback for this coaching session. You may close this dialog now.</p>
        } @else {
            @if (canProvideFeedback) {
                <h3>Please provide feedback for your coach and your session</h3>
                <p>We appreciate any feedback you can provide about our coach, the coaching session, or anything else you would like to let
                    us know about.</p>
                <div class="text-center">
                    <adapt-rating-stars [(rating)]="coachSession.feedbackRating"
                                        (ratingChange)="updateFeedbackState()"></adapt-rating-stars>
                </div>
                <h4>Comments</h4>
                <dx-text-area [(value)]="coachSession.feedbackComment"
                              (valueChange)="updateFeedbackState()"
                              placeholder="Enter your feedback here..."></dx-text-area>
            } @else {
                @if (isSessionForCurrentPerson) {
                    <p>Sorry, you can't provide feedback for this coaching session until the session has been completed.</p>
                    <p>If the session has finished, please follow up with your coach.</p>
                } @else {
                    <p>You cannot provide feedback for another person's coaching session.</p>
                    <p>If this is a mistake, please follow up with your coach.</p>
                }
            }
        }
    </ng-container>

    <ng-container adapt-dialog-footer>
        @if (!alreadyHasFeedback && canProvideFeedback) {
            <adapt-standard-dialog-buttons adapt-dialog-footer
                                           [discardConfirmationInstance]="instance"
                                           [saveIsDisabled]="!coachSession.feedbackComment && !coachSession.feedbackRating"></adapt-standard-dialog-buttons>
        } @else {
            <div class="ms-auto">
                <button adaptButton="close"
                        (click)="cancel()"></button>
            </div>
        }
    </ng-container>
</adapt-dialog>
